<div class="router-bar">
    <div class="route-buttons">
        <div class="route-button" [ngClass]="{'current-route': router.url === '/planning'}">
            <button mat-button [routerLink]="['/planning']">Activities</button>
        </div>
        <div class="route-button" [ngClass]="{'current-route': router.url === '/production'}">
            <button mat-button [routerLink]="['/production']">Production Posts</button>
        </div>
    </div>
    <div class="delimiter"></div>
    <div class="view-buttons">
        <button mat-button [disableRipple]="true" [class.active]="activeType === 'ENGINEERING'" (click)="setActiveType('ENGINEERING')">Engineering</button>
        <button mat-button [disableRipple]="true" [class.active]="activeType === 'MATERIAL'" (click)="setActiveType('MATERIAL')">Material Ordering</button>
    </div>
</div>

<div class="calendar-container" cdkDropListGroup>
    <!-- Column 1 - Shows red underline -->
    <app-engineering-column *ngFor="let column of data.columns" [column]="column" [device]="deviceInfo"
        class="calendar-column {{column.title}}"></app-engineering-column>
</div>